const request = {
    invalid_input: 'Input inválido. {{details}}',
    general: 'Ocorreu um erro no pedido.',
};
export default Object.freeze(request);
